import axios from 'axios';

const baseDomain = '/';

const headersDefault = {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest',};

const http = (baseURL = baseDomain, headers = headersDefault) => axios.create({baseURL, headers,});

export default http
